import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map, Observable, Subject, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
// import {
//     EditRequestAssigneePayload,
//     EditRequestPriorityPayload,
//     EditRequestStatusPayload,
// } from './cereri-detalii/actualizare-cerere/actualizare-cerere.interface';
import {
    DocumentData,
    EditRequestAssigneePayload,
    EditRequestPriorityPayload,
    EditRequestStatusPayload,
    extraActionCererePayload,
    IInchidereLucrare,
    UpdateMassAssignPayload,
    UpdateMassStatusPayload,
} from './cereri.interface';

@Injectable({
    providedIn: 'root',
})
export class CereriService {
    private token!: string;
    private httpOptions: any;

    private basePath = environment.interop.basePath;
    private getRequestsURL =
        this.basePath + environment.interop.dgaspc.cerere.getCereriList;
    private getRequestsDTURL =
        this.basePath + environment.interop.dgaspc.cerere.getCereriListDT;
    private findCerere =
        this.basePath + environment.interop.dgaspc.cerere.findCerere;
    private getInfoDocListURL =
        this.basePath + environment.interop.dgaspc.cerere.getInfoDocList;
    private storeRequestsURL =
        this.basePath + environment.interop.dgaspc.cerere.storeCereri;
    private updateRequestURL =
        this.basePath + environment.interop.dgaspc.cerere.updateCereri;
    private deleteRequestURL =
        this.basePath + environment.interop.dgaspc.cerere.deleteCereri;
    private updateStatusURL =
        this.basePath + environment.interop.dgaspc.cerere.updateStatus;
    private updatePriorityURL =
        this.basePath + environment.interop.dgaspc.cerere.updatePriority;
    private updateAssigneeURL =
        this.basePath + environment.interop.dgaspc.cerere.updateAssignee;

    private postMessageURL =
        this.basePath + environment.interop.dgaspc.cerere.postMessage;
    private rePostMessageURL =
        this.basePath + environment.interop.dgaspc.cerere.rePostMessage;

    private cerereUpdateMetadateUrl =
        this.basePath + environment.interop.dgaspc.cerere.cerereUpdateMetadate;

    // new routes
    private preluarePersonalaUrl =
        this.basePath + environment.interop.dgaspc.cerere.preluarePersonala;
    private preluareNumarRegistraturaUrl =
        this.basePath +
        environment.interop.dgaspc.cerere.preluareNumarRegistratura;
    private validateCerereUrl =
        this.basePath + environment.interop.dgaspc.cerere.validateCerere;
    private invalidateCerereUrl =
        this.basePath + environment.interop.dgaspc.cerere.invalidateCerere;
    private anulareCerereUrl =
        this.basePath + environment.interop.dgaspc.cerere.anulareCerere;
    private finalizareCerereUrl =
        this.basePath + environment.interop.dgaspc.cerere.finalizareCerere;
    private getCerereTypesUrl =
        this.basePath + environment.interop.dgaspc.nomenclatoare.cerereType.listActive;

    private getOperatoriByCompartimentUrl =
        this.basePath + environment.interop.dgaspc.nomenclatoare.operatori.getOperatoriByCompartiment;

    // operations
    public downloadDocumentUrl =
        this.basePath + environment.interop.dgaspc.cerere.downloadDocument;

    private fileUploadUrl =
        this.basePath + environment.interop.dgaspc.cerere.file.fileUpload;
    private fileUploadBase64Url =
        this.basePath + environment.interop.dgaspc.cerere.file.fileUploadBase64;
    public tempFileDownloadUrl =
        this.basePath + environment.interop.dgaspc.cerere.file.tempFileDownload;

    private generateDocumentUrl =
        this.basePath + environment.interop.dgaspc.cerere.generateDocument;

    private generateDocumentWithFileUrl =
        this.basePath + environment.interop.dgaspc.cerere.uploadOnlineDocument;

    private validateDocumentUrl =
        this.basePath + environment.interop.dgaspc.cerere.validateDocument;

    private resetDocumentValidatedUrl =
        this.basePath + environment.interop.dgaspc.cerere.resetDocumentValidated;

    private resetDocumentIntocmitorValidatedUrl =
        this.basePath +
        environment.interop.dgaspc.cerere.resetDocumentIntocmitorValidated;

    private uploadFinalDocumentUrl =
        this.basePath + environment.interop.dgaspc.cerere.uploadedFinalDocument;

    private addToRegistruUrl =
        this.basePath + environment.interop.dgaspc.cerere.addToRegistru;

    public downloadDocumentOfficialUrl =
        this.basePath +
        environment.interop.dgaspc.cerere.downloadDocumentOfficial;

    private istoricDocumentUrl =
        this.basePath + environment.interop.dgaspc.cerere.istoricDocument;

    private destroyDocumentUrl =
        this.basePath + environment.interop.dgaspc.cerere.destroyDocument;

    private updateDocumentUrl =
        this.basePath + environment.interop.dgaspc.cerere.updateDocument;

    private updateValabilityDocGenerabilUrl =
        this.basePath +
        environment.interop.dgaspc.cerere.editValabilitateDocGenerabil;

    private validateDocumentSuperiorUrl =
        this.basePath +
        environment.interop.dgaspc.cerere.validateDocumentSuperior;

    public downloadDocumentSignedUrl =
        this.basePath + environment.interop.dgaspc.cerere.downloadDocumentSigned;

    public downloadDocumentGeneratUrl =
        this.basePath + environment.interop.dgaspc.cerere.downloadDocumentGenerat;

    public downloadDocumentSignatureSignedUrl =
        this.basePath +
        environment.interop.dgaspc.cerere.downloadDocumentSignatureSigned;

    public downloadDocumentAnexaUrl =
        this.basePath + environment.interop.dgaspc.cerere.downloadDocumentAnexa;

    private anulareSuperiorDocumentUrl =
        this.basePath + environment.interop.dgaspc.cerere.cancelDocumentSuperior;

    private generareDraftURL =
        this.basePath + environment.interop.dgaspc.cerere.generareDraft;

    // Directii

    private getDirectiiActiveUrl =
        this.basePath +
        environment.interop.dgaspc.nomenclatoare.directie.getDirectiiActive;

    // Compartimente

    private getCompartimenteActiveUrl =
        this.basePath +
        environment.interop.dgaspc.nomenclatoare.compartiment
            .getCompartimenteActive;

    private getCompartimenteByDirectieUrl =
        this.basePath +
        environment.interop.dgaspc.nomenclatoare.compartiment
            .getCompartimenteByDirectie;

    private getCompartimenteByUrbanismUrl =
        this.basePath + environment.interop.dgaspc.nomenclatoare.compartiment.getCompartimenteByDgaspc;

    // Mass update & assign

    private massUpdateStatusURL =
        this.basePath + environment.interop.dgaspc.cerere.massUpdateStatus;

    private massAssignURL =
        this.basePath + environment.interop.dgaspc.cerere.massAssign;

    public downloadTableSignaturesURL =
        this.basePath + environment.interop.dgaspc.cerere.downloadTableSignatures;

    private sablonContent = new Subject<string>();
    sablonContent$ = this.sablonContent.asObservable();

    private sendDocumentToIntocmitorUrl =
        this.basePath +
        environment.interop.dgaspc.cerere.sendDocumentToIntocmitor;
    private sendDocumentForwardIntocmitorUrl =
        this.basePath +
        environment.interop.dgaspc.cerere.sendDocumentForwardIntocmitor;
    private sendDocumentForwardToSignerUrl =
        this.basePath +
        environment.interop.dgaspc.cerere.sendDocumentForwardToSigner;

    private rsyncSignaturesDocumentGeneratUrl =
        this.basePath +
        environment.interop.dgaspc.cerere.rsyncSignaturesDocumentGenerat;

    private exportHistoryUrl =
        this.basePath + environment.interop.dgaspc.cerere.exportHistory;

    private resetValidareCerereUrl =
        this.basePath + environment.interop.dgaspc.cerere.resetValidareCerere;

    private resetinValidareCerereUrl =
        this.basePath + environment.interop.dgaspc.cerere.resetinValidareCerere;

    private resetClasareCerereUrl =
        this.basePath + environment.interop.dgaspc.cerere.resetClasareCerere;

    private resetInchidereCerereUrl =
        this.basePath + environment.interop.dgaspc.cerere.resetInchidereCerere;

    private sendNotificationCetateanDocumentOficialUrl =
        this.basePath +
        environment.interop.dgaspc.cerere.sendNotificationCetateanDocumentOficial;

    private resetDocumentOficialNotificareCetateanUrl =
        this.basePath +
        environment.interop.dgaspc.cerere.resetDocumentOficialNotificareCetatean;

    private resetUploadDocumentOfficialUrl =
        this.basePath +
        environment.interop.dgaspc.cerere.resetUploadDocumentOfficial;

    public downloadManualUrl =
        this.basePath + environment.interop.dgaspc.cerere.downloadManual;

    private setDocTypeForDocumentUrl =
        this.basePath + environment.interop.dgaspc.cerere.setDocTypeForDocument;

    private updateCurrentSignatureDocumentUrl =
        this.basePath + environment.interop.dgaspc.cerere.updateCurrentSignatureDocument;

    private allowMessagesUrl =
        this.basePath + environment.interop.dgaspc.cerere.allowMessages;

    private getJudeteUrl =
        environment.interop.authCore.basePath + environment.interop.dgaspc.nomenclatoare.judet.listActive;

    constructor(private http: HttpClient) { }

    getRequestTypes(id: number) {
        let payload = { compartiment: id };

        return this.http
            .get<{ errors: boolean; data: any[]; status_code: number }>(
                this.getCerereTypesUrl, { params: payload }
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => ({
                        id: item.id,
                        name: item.name,
                    }))
                ),
                catchError((error) => {
                    console.error('Error in get request types:', error);
                    return throwError(error);
                })
            );
    }

    getOperatoriByCompartiment(id: number) {
        return this.http
            .get<{ errors: boolean; data: any[]; status_code: number }>(
                this.getOperatoriByCompartimentUrl + id
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => ({
                        id: item.id_user,
                        name: item.name,
                    }))
                ),
                catchError((error) => {
                    console.error('Error in get operatori by compartiment:', error);
                    return throwError(error);
                })
            );
    }

    getRequests() {
        return this.http.get(this.getRequestsURL, this.httpOptions);
    }

    generareDraft(id_cerere: number) {
        return this.http.get(this.generareDraftURL + id_cerere, {
            responseType: 'blob',
        });
    }

    getRequestsDT() {
        return this.http.get(this.getRequestsDTURL, this.httpOptions);
    }

    getRequestById(id: number) {
        return this.http.get(this.findCerere + id);
    }

    // addRequest(request: AddCererePayload) {
    //     return this.http.post(this.storeRequestsURL, request, this.httpOptions);
    // }

    // updateRequest(request: EditCererePayload) {
    //     return this.http.put(this.updateRequestURL, request, this.httpOptions);
    // }

    deleteRequest(id: number) {
        return this.http.delete(this.deleteRequestURL + id);
    }

    getInfoDocList(id: number) {
        return this.http.get(this.getInfoDocListURL + id);
    }

    updateRequestStatus(requestId: number, status: EditRequestStatusPayload) {
        return this.http.put(
            this.updateStatusURL + requestId,
            status,
            this.httpOptions
        );
    }

    updateRequestPriority(
        requestId: number,
        priority: EditRequestPriorityPayload
    ) {
        return this.http.put(
            this.updatePriorityURL + requestId,
            priority,
            this.httpOptions
        );
    }

    updateRequestAssignee(requestId: number, data: EditRequestAssigneePayload) {
        return this.http.put(
            this.updateAssigneeURL + requestId,
            data,
            this.httpOptions
        );
    }

    postMessage(id: number, message: any) {
        return this.http.post(this.postMessageURL + id, message, this.httpOptions);
    }

    rePostMessage(id: number) {
        return this.http.post(this.rePostMessageURL + id, this.httpOptions);
    }

    preluarePersonala(cerereId: number) {
        return this.http.get(
            this.preluarePersonalaUrl + cerereId,
            this.httpOptions
        );
    }

    validateCerere(cerereId: number) {
        return this.http.post(this.validateCerereUrl + cerereId, this.httpOptions);
    }

    invalidateCerere(cerereId: number, data: extraActionCererePayload) {
        return this.http.post(
            this.invalidateCerereUrl + cerereId,
            data,
            this.httpOptions
        );
    }

    anulareCerere(cerereId: number, data: extraActionCererePayload) {
        return this.http.post(
            this.anulareCerereUrl + cerereId,
            data,
            this.httpOptions
        );
    }

    finalizareCerere(cerereId: number, data: IInchidereLucrare) {
        return this.http.post(
            this.finalizareCerereUrl + cerereId,
            data,
            this.httpOptions
        );
    }

    setToken(token: string) {
        this.token = token;
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: `Bearer ${this.token}`,
            }),
        };
    }

    fileUpload(formData: FormData) {
        return this.http.post<{ data: any }>(this.fileUploadUrl, formData);
    }

    generateDocument(cerereId: number, templateId: number, data: any) {
        return this.http.post<{ data: any }>(
            this.generateDocumentUrl + cerereId + '/' + templateId,
            data
        );
    }

    generateDocumentWithFile(cerereId: number, data: any) {
        return this.http.post<{ data: any }>(
            this.generateDocumentWithFileUrl + cerereId,
            data
        );
    }
    validateDocument(id: number, type: number, data: DocumentData) {
        // small switch here
        // || type == 2 => old, now removing
        let path =
            type == 1
                ? this.validateDocumentUrl
                : this.validateDocumentSuperiorUrl;
        return this.http.post(path + id, data);
    }

    resetDocumentValidated(id: number, data: any) {
        return this.http.post(this.resetDocumentValidatedUrl + id, data);
    }

    resetDocumentIntocmitorValidated(id: number, data: any) {
        return this.http.post(this.resetDocumentIntocmitorValidatedUrl + id, data);
    }

    uploadFinalDocument(id: number, data: DocumentData) {
        return this.http.post(this.uploadFinalDocumentUrl + id, data);
    }

    addToRegistru(
        cerere_id: number,
        document_id: number,
        data: { valability: Date }
    ) {
        return this.http.post(
            this.addToRegistruUrl + cerere_id + '/' + document_id,
            data
        );
    }

    editDocGenerabilValabilty(document_id: number, data: { valability: Date }) {
        return this.http.post(
            this.updateValabilityDocGenerabilUrl + document_id,
            data
        );
    }

    downloadDocumentOfficial(id: number) {
        return this.http.get(this.downloadDocumentOfficialUrl + id);
    }

    downloadTableSignatures(id: number) {
        return this.http.get(this.downloadTableSignaturesURL + id);
    }

    downloadDocumentSigned(id: number) {
        return this.http.get(this.downloadDocumentSignedUrl + id);
    }

    downloadDocumentGenerat(id: number) {
        return this.http.get(this.downloadDocumentGeneratUrl + id);
    }

    downloadDocumentSignatureSigned(id: number) {
        return this.http.get(this.downloadDocumentSignatureSignedUrl + id);
    }

    downloadDocumentAnexa(id: number) {
        return this.http.get(this.downloadDocumentAnexaUrl + id);
    }

    istoricDocument(id: number) {
        return this.http.get(this.istoricDocumentUrl + id);
    }

    destroyDocument(id: number, data: any) {
        return this.http.post(this.destroyDocumentUrl + id, data);
    }

    updateDocument(id: number, data: DocumentData) {
        return this.http.post(this.updateDocumentUrl + id, data);
    }

    anulareSuperiorDocument(signatureId: number, data: any) {
        return this.http.post(this.anulareSuperiorDocumentUrl + signatureId, data);
    }

    getDirectii() {
        return this.http
            .get<{ errors: boolean; data: any[]; status_code: number }>(
                this.getDirectiiActiveUrl
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => ({
                        id: item.id_directie,
                        name: item.name,
                    }))
                ),
                catchError((error) => {
                    console.error('Error in get directii active:', error);
                    return throwError(error);
                })
            );
    }

    getCompartimenteActive() {
        return this.http
            .get<{ errors: boolean; data: any[]; status_code: number }>(
                this.getCompartimenteActiveUrl
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => ({
                        id: item.id_compartiment,
                        name: item.name,
                    }))
                ),
                catchError((error) => {
                    console.error('Error in get compartimente active:', error);
                    return throwError(error);
                })
            );
    }

    getCompartimenteByDirectieId(id: number) {
        return this.http
            .get<{ errors: boolean; data: any[]; status_code: number }>(
                this.getCompartimenteByDirectieUrl + id
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => ({
                        id: item.id_compartiment,
                        name: item.name,
                    }))
                ),
                catchError((error) => {
                    console.error('Error in getCompartimenteByDirectieId:', error);
                    return throwError(error);
                })
            );
    }

    getCompartimenteByUrbanism() {
        return this.http
            .get<{ errors: boolean; data: any[]; status_code: number }>(
                this.getCompartimenteByUrbanismUrl
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => ({
                        id: item.id_compartiment,
                        name: item.name,
                    }))
                ),
                catchError((error) => {
                    console.error('Error in getCompartimenteByDirectieId:', error);
                    return throwError(error);
                })
            );
    }

    getRequestsIDs() {
        return this.http.get<any>(this.getRequestsDTURL).pipe(
            map((response) =>
                response.data.data.map((item: any) => ({
                    id: item.id_cerere,
                    name: item.subject,
                }))
            ),
            catchError((error) => {
                console.error('Error in get requests select:', error);
                return throwError(error);
            })
        );
    }

    updateMassAssign(data: UpdateMassAssignPayload) {
        return this.http.post(this.massAssignURL, data, this.httpOptions);
    }

    updateMassStatus(data: UpdateMassStatusPayload) {
        return this.http.post(this.massUpdateStatusURL, data, this.httpOptions);
    }

    preluareNumarRegistratura(cerereId: number) {
        return this.http.put(
            this.preluareNumarRegistraturaUrl + cerereId,
            this.httpOptions
        );
    }

    sendContent(content: string) {
        this.sablonContent.next(content);
    }

    sendDocumentToIntocmitor(signatureId: number, data: any) {
        return this.http.put(this.sendDocumentToIntocmitorUrl + signatureId, data);
    }

    sendDocumentForwardIntocmitor(documentId: number, data: any) {
        return this.http.put(
            this.sendDocumentForwardIntocmitorUrl + documentId,
            data
        );
    }

    sendDocumentForwardToSigner(signatureId: number, data: any) {
        return this.http.put(
            this.sendDocumentForwardToSignerUrl + signatureId,
            data
        );
    }

    rsyncSignaturesDocumentGenerat(documentId: number, data: any = {}) {
        return this.http.post(
            this.rsyncSignaturesDocumentGeneratUrl + documentId,
            data
        );
    }

    exportHistory(cerere_id: number, user_type: number): Observable<Blob> {
        return this.http.get(this.exportHistoryUrl + cerere_id + '/' + user_type, {
            responseType: 'blob',
        });
    }

    resetValidareCerere(cerereId: number, data: any) {
        return this.http.put(this.resetValidareCerereUrl + cerereId, data);
    }

    resetinValidareCerere(cerereId: number, data: any) {
        return this.http.put(this.resetinValidareCerereUrl + cerereId, data);
    }

    resetClasareCerere(cerereId: number, data: any) {
        return this.http.put(this.resetClasareCerereUrl + cerereId, data);
    }

    resetInchidereCerere(cerereId: number, data: any) {
        return this.http.post(this.resetInchidereCerereUrl + cerereId, data);
    }

    sendNotificationCetateanDocumentOficial(documentGeneratId: number) {
        return this.http.get(
            this.sendNotificationCetateanDocumentOficialUrl + documentGeneratId,
            this.httpOptions
        );
    }

    resetDocumentOficialNotificareCetatean(id: number) {
        return this.http.post(
            this.resetDocumentOficialNotificareCetateanUrl + id,
            this.httpOptions
        );
    }

    resetUploadDocumentOfficial(id_document: number) {
        return this.http.post(
            this.resetUploadDocumentOfficialUrl + id_document,
            this.httpOptions
        );
    }

    downloadManual() {
        return this.http.get(this.downloadManualUrl);
    }

    cerereUpdateMetadate(id: number, data: any) {
        return this.http.put(this.cerereUpdateMetadateUrl + id, data);
    }

    setDocTypeForDocument(id: number) { // id => id_document - generat
        return this.http.get(this.setDocTypeForDocumentUrl + id, this.httpOptions);
    }

    updateCurrentSignatureDocument(documentId: number, data: any) {
        return this.http.put(
            this.updateCurrentSignatureDocumentUrl + documentId,
            data,
            this.httpOptions
        );
    }

    allowMessages(id: number) {
        return this.http.put(this.allowMessagesUrl + id, this.httpOptions);
    }

    getJudete() {
        return this.http
            .get<{ errors: boolean; data: any[]; status_code: number }>(
                this.getJudeteUrl
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => ({
                        id: item.id,
                        name: item.name,
                    }))
                ),
                catchError((error) => {
                    console.error('Error in get registre:', error);
                    return throwError(error);
                })
            );
    }

    // ==================== Ajutoare Etape Decontare ==================== //

    approveEtapaDocs(etapaId: number, obs: string = ''): Observable<any> {
        return this.http.post(`${this.basePath}api/cerere/etapa/${etapaId}/approve-docs`, { observatii: obs });
    }

    rejectEtapaDocs(etapaId: number, motiv: string, allowReupload: boolean): Observable<any> {
        return this.http.post(`${this.basePath}api/cerere/etapa/${etapaId}/reject-docs`, { motiv, allow_reupload: allowReupload });
    }

    unlockEtapa(etapaId: number): Observable<any> {
        return this.http.post(`${this.basePath}api/cerere/etapa/${etapaId}/unlock`, {});
    }

    confirmPayment(etapaId: number, suma: number, referinta: string): Observable<any> {
        return this.http.post(`${this.basePath}api/cerere/etapa/${etapaId}/payment`, { suma, referinta });
    }

    batchDecontare(cerereIds: number[], etapaNr: number): Observable<any> {
        return this.http.post(`${this.basePath}api/cerere/ajutoare/batch-decontare`, { cerere_ids: cerereIds, etapa_nr: etapaNr });
    }

    batchConfirmPlata(cerereIds: number[], etapaNr: number, suma: number, ref: string): Observable<any> {
        return this.http.post(`${this.basePath}api/cerere/ajutoare/batch-confirm-plata`, {
            cerere_ids: cerereIds, etapa_nr: etapaNr, suma_per_cerere: suma, referinta: ref
        });
    }

    getRaportDecontare(params: any): Observable<any> {
        return this.http.get(`${this.basePath}api/cerere/ajutoare/raport-decontare`, { params });
    }

    // ==================== Cerere Function Assignments ==================== //

    /**
     * Get assignments for a specific cerere
     */
    getCerereAssignments(cerereId: number): Observable<any> {
        const url = `${this.basePath}api/cerere/${cerereId}/functie-assignments`;
        return this.http.get<any>(url, this.httpOptions).pipe(
            catchError((error) => {
                console.error('Error getting cerere assignments:', error);
                return throwError(error);
            })
        );
    }

    /**
     * Initialize assignments from cerere type template
     */
    initializeCerereAssignments(cerereId: number): Observable<any> {
        const url = `${this.basePath}api/cerere/${cerereId}/functie-assignments/initialize`;
        return this.http.post<any>(url, {}, this.httpOptions).pipe(
            catchError((error) => {
                console.error('Error initializing cerere assignments:', error);
                return throwError(error);
            })
        );
    }

    /**
     * Update assignments for a specific cerere
     */
    updateCerereAssignments(cerereId: number, assignmentsData: any): Observable<any> {
        const url = `${this.basePath}api/cerere/${cerereId}/functie-assignments`;
        return this.http.put<any>(url, assignmentsData, this.httpOptions).pipe(
            catchError((error) => {
                console.error('Error updating cerere assignments:', error);
                return throwError(error);
            })
        );
    }

    /**
     * Assign user to a specific function assignment
     */
    assignUserToCerereFunction(cerereId: number, assignmentId: number, userData: any): Observable<any> {
        const url = `${this.basePath}api/cerere/${cerereId}/functie-assignments/${assignmentId}/assign-user`;
        return this.http.put<any>(url, userData, this.httpOptions).pipe(
            catchError((error) => {
                console.error('Error assigning user to cerere function:', error);
                return throwError(error);
            })
        );
    }

    /**
     * Unassign user from a specific function assignment
     */
    unassignUserFromCerereFunction(cerereId: number, assignmentId: number): Observable<any> {
        const url = `${this.basePath}api/cerere/${cerereId}/functie-assignments/${assignmentId}/unassign-user`;
        return this.http.delete<any>(url, this.httpOptions).pipe(
            catchError((error) => {
                console.error('Error unassigning user from cerere function:', error);
                return throwError(error);
            })
        );
    }

    /**
     * Mark assignment as completed
     */
    markCerereAssignmentCompleted(cerereId: number, assignmentId: number): Observable<any> {
        const url = `${this.basePath}api/cerere/${cerereId}/functie-assignments/${assignmentId}/mark-completed`;
        return this.http.put<any>(url, {}, this.httpOptions).pipe(
            catchError((error) => {
                console.error('Error marking cerere assignment as completed:', error);
                return throwError(error);
            })
        );
    }

    /**
     * Clear all assignments for a cerere
     */
    clearAllCerereAssignments(cerereId: number): Observable<any> {
        const url = `${this.basePath}api/cerere/${cerereId}/functie-assignments/clear-all`;
        return this.http.delete<any>(url, this.httpOptions).pipe(
            catchError((error) => {
                console.error('Error clearing all cerere assignments:', error);
                return throwError(error);
            })
        );
    }

    /**
     * Get available functii for assignments
     */
    getAvailableFunctii(): Observable<any> {
        const url = `${this.basePath}api/nomenclatoare/cerere-type/available-functii`;
        return this.http.get<any>(url, this.httpOptions).pipe(
            catchError((error) => {
                console.error('Error getting available functii:', error);
                return throwError(error);
            })
        );
    }

    /**
     * Get available directii for assignments
     */
    getAvailableDirectii(): Observable<any> {
        const url = `${this.basePath}api/nomenclatoare/cerere-type/available-directii`;
        return this.http.get<any>(url, this.httpOptions).pipe(
            catchError((error) => {
                console.error('Error getting available directii:', error);
                return throwError(error);
            })
        );
    }

    /**
     * Get compartimente by directie for assignments (for cerere-type context)
     */
    getCompartimenteByDirectie(directieId: number): Observable<any> {
        const url = `${this.basePath}api/nomenclatoare/cerere-type/available-directii/${directieId}/compartimente`;
        return this.http.get<any>(url, this.httpOptions).pipe(
            catchError((error) => {
                console.error('Error getting compartimente by directie:', error);
                return throwError(error);
            })
        );
    }

    /**
     * Get available users by directie and optional compartiment (for cerere assignments)
     */
    getAvailableUsers(directieId: number, compartimentId?: number): Observable<any> {
        let url = `${this.basePath}api/cerere/functie-assignments/available-users/${directieId}`;
        if (compartimentId) {
            url += `/${compartimentId}`;
        }
        return this.http.get<any>(url, this.httpOptions).pipe(
            catchError((error) => {
                console.error('Error getting available users:', error);
                return throwError(error);
            })
        );
    }

    /**
     * Get compartimente by directie for cerere assignments
     */
    getCompartimenteByDirectieForCerere(directieId: number): Observable<any> {
        const url = `${this.basePath}api/cerere/functie-assignments/available-directii/${directieId}/compartimente`;
        return this.http.get<any>(url, this.httpOptions).pipe(
            catchError((error) => {
                console.error('Error getting compartimente by directie for cerere:', error);
                return throwError(error);
            })
        );
    }

    /**
     * Get available users by directie and optional compartiment for specific cerere type
     */
    getAvailableUsersForCerereType(cerereTypeId: number, directieId: number, compartimentId?: number): Observable<any> {
        let url = `${this.basePath}api/nomenclatoare/cerere-type/${cerereTypeId}/available-users/${directieId}`;
        if (compartimentId) {
            url += `/${compartimentId}`;
        }
        return this.http.get<any>(url, this.httpOptions).pipe(
            catchError((error) => {
                console.error('Error getting available users for cerere type:', error);
                return throwError(error);
            })
        );
    }

    /**
     * Get compartimente by directie for specific cerere type
     */
    getCompartimenteByDirectieForCerereType(cerereTypeId: number, directieId: number): Observable<any> {
        // For now we'll use the general compartimente endpoint since it's not cerere-type specific
        // but we could enhance this if needed
        const url = `${this.basePath}api/nomenclatoare/cerere-type/available-directii/${directieId}/compartimente`;
        return this.http.get<any>(url, this.httpOptions).pipe(
            catchError((error) => {
                console.error('Error getting compartimente by directie for cerere type:', error);
                return throwError(error);
            })
        );
    }

    // ==================== Document Assignment Management ==================== //

    /**
     * Get enriched assignment details for a document
     */
    getDocumentAssignmentDetails(documentId: number): Observable<any> {
        const url = `${this.basePath}api/cerere/document/${documentId}/assignment-details`;
        return this.http.get<any>(url, this.httpOptions).pipe(
            catchError((error) => {
                console.error('Error getting document assignment details:', error);
                return throwError(error);
            })
        );
    }

    /**
     * Manually assign operator to document
     */
    assignOperatorToDocument(documentId: number, assignmentData: any): Observable<any> {
        const url = `${this.basePath}api/cerere/document/${documentId}/assign-operator`;
        return this.http.post<any>(url, assignmentData, this.httpOptions).pipe(
            catchError((error) => {
                console.error('Error assigning operator to document:', error);
                return throwError(error);
            })
        );
    }

    /**
     * Update existing document assignment
     */
    updateDocumentAssignment(documentId: number, assignmentData: any): Observable<any> {
        const url = `${this.basePath}api/cerere/document/${documentId}/update-assignment`;
        return this.http.put<any>(url, assignmentData, this.httpOptions).pipe(
            catchError((error) => {
                console.error('Error updating document assignment:', error);
                return throwError(error);
            })
        );
    }

    /**
     * Remove assignment from document
     */
    unassignDocumentOperator(documentId: number): Observable<any> {
        const url = `${this.basePath}api/cerere/document/${documentId}/unassign-operator`;
        return this.http.delete<any>(url, this.httpOptions).pipe(
            catchError((error) => {
                console.error('Error unassigning document operator:', error);
                return throwError(error);
            })
        );
    }

    /**
     * Get available operators from cerere assignments for document assignment
     */
    getAvailableOperatorsForDocument(documentId: number): Observable<any> {
        const url = `${this.basePath}api/cerere/document/${documentId}/available-operators`;
        return this.http.get<any>(url, this.httpOptions).pipe(
            map((response: any) => response.data || []),
            catchError((error) => {
                console.error('Error getting available operators for document:', error);
                return throwError(error);
            })
        );
    }

    /**
     * Auto-assign all unassigned documents for a cerere
     */
    autoAssignAllDocumentsForCerere(cerereId: number): Observable<any> {
        const url = `${this.basePath}api/cerere/cerere/${cerereId}/auto-assign-documents`;
        return this.http.post<any>(url, {}, this.httpOptions).pipe(
            catchError((error) => {
                console.error('Error auto-assigning documents for cerere:', error);
                return throwError(error);
            })
        );
    }

    /**
     * Get document assignments summary for a cerere
     */
    getDocumentAssignmentsSummaryForCerere(cerereId: number): Observable<any> {
        const url = `${this.basePath}api/cerere/cerere/${cerereId}/document-assignments-summary`;
        return this.http.get<any>(url, this.httpOptions).pipe(
            catchError((error) => {
                console.error('Error getting document assignments summary:', error);
                return throwError(error);
            })
        );
    }
}
